import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// MODULES/MODULOS  -------------------------------------------------------
import { AgmCoreModule } from '@agm/core';
import { FormsModule } from '@angular/forms';
import { routing } from '../user/user-routing.module';
import { ShareModule } from '@asambleas-modules/share/share.module';

// COMPONENTS/COMPONENTES  ------------------------------------------------
import { UserComponent } from './user.component';
import { UserHomeComponent } from './user-home/user-home.component';
import { SidebarComponent } from '../components/user/sidebar/sidebar.component';
import { NavbarUserComponent } from '../components/user/navbar-user/navbar-user.component';


@NgModule({
    declarations: [
        UserComponent,
        UserHomeComponent,
        NavbarUserComponent,
        SidebarComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ShareModule,
        routing,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyD8ZXnKF9EQwSV1XgZwGYTcn3NO4ItR9KU'
        }),
    ]
})
export class UserModule { }



// WEBPACK FOOTER //
// ./src/app/user/user.module.ts